import { useState } from "react";
import { IPaginationPayload } from "../../../interfaces/shared/IPaginationPayload";
import { useGetAllDraftsQuery } from "../../../store/reservations/reservationsApi";
import DraftsRequestTable from "./tables/DraftsRequestTable";
import DraftFilters from "./filters/DraftFilters";
import { capitalizeWords } from "../../../utils/capitalizeText";
import SummaryEmailTable from "./tables/SummaryEmailTable";

const DraftsRequests = () => {
  const [paginationState, setPaginationState] = useState<IPaginationPayload>({
    pageNumber: 1,
    pageSize: 10,
    filters: "all",
  });
  const { data, isLoading } = useGetAllDraftsQuery({ ...paginationState });

  const onChangeFilterSelected = (
    value: { value: string; label: string },
    type?: string
  ) => {
    if (type) {
      switch (type) {
        case "status":
          setPaginationState({ ...paginationState, filters: value.value });
          break;
      }
    }
  };

  return (
    <div>
      <div>
        <p className="page-title">Drafts</p>
      </div>
      <DraftFilters
        selectedStatus={{
          value: paginationState.filters || "",
          label: capitalizeWords(paginationState.filters || ""),
        }}
        onClickFilter={onChangeFilterSelected}
      />
      <div className="flex flex-wrap">
        <div className="w-full lg:w-8/12 xl:w-9/12">
          <DraftsRequestTable
            rows={data?.data?.items.elements || []}
            paginationData={data?.data.items.page}
            rowsLoading={isLoading}
            setPaginationState={setPaginationState}
          />
        </div>
        <div className="w-full lg:w-4/12 xl:w-3/12 px-4">
          <SummaryEmailTable />
        </div>
      </div>
    </div>
  );
};

export default DraftsRequests;
